"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledModalOverlay = exports.StyledModalLinkContainer = exports.StyledModalLink = exports.StyledModalGridRow = exports.StyledModalGridItem = exports.StyledModalGridContainer = exports.StyledModalFooter = exports.StyledModalContainer = exports.StyledModalButton = exports.StyledModalBody = exports.StyledModal = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _buttons = require("../../fuse-buttons/src/buttons");
var _elevation = require("../../fuse-elevation/src/elevation");
var _links = require("../../fuse-link/src/links");
var _grid = require("../../fuse-responsive-grid/src/grid");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
// Box-shadow size from elevation to be used as background size to emulate sticky header drop shadow in modal body
var xxsShadowSize = _elevation.elevation.shadow[16].split(/\s/)[2];
var mShadowSize = _elevation.elevation.shadow[24].split(/\s/)[2];
var xlShadowSize = _elevation.elevation.shadow[24].split(/\s/)[2];
// Modal Styles Config
var stylesConfig = {
  xxs: {
    maxHeightMargin: 'var(--spacing-global-space5)',
    bodyPadding: 'var(--spacing-global-space6) var(--spacing-global-space5) var(--spacing-global-space7)',
    bodyBackground: "linear-gradient(var(--color-functional-panelLight), 70%, rgba(255,255,255,0)) local no-repeat, linear-gradient(rgba(0,0,0,0.2), 2px, rgba(255,255,255,0)) scroll no-repeat",
    bodyBackgroundSize: "100% ".concat(xxsShadowSize, ", 100% ").concat(xxsShadowSize)
  },
  m: {
    maxHeightMargin: 'var(--spacing-global-space6)',
    bodyPadding: 'var(--spacing-global-space7) var(--spacing-global-space6) var(--spacing-global-space8)',
    bodyBackground: "linear-gradient(var(--color-functional-panelLight), 70%, rgba(255,255,255,0)) local no-repeat, linear-gradient(rgba(0,0,0,0.2), 2px, rgba(255,255,255,0)) scroll no-repeat",
    bodyBackgroundSize: "100% ".concat(mShadowSize, ", 100% ").concat(mShadowSize)
  },
  xl: {
    maxHeightMargin: 'var(--spacing-global-space7)',
    bodyPadding: 'var(--spacing-global-space7) var(--spacing-global-space7) var(--spacing-global-space8)',
    bodyBackground: "linear-gradient(var(--color-functional-panelLight), 70%, rgba(255,255,255,0)) local no-repeat, linear-gradient(rgba(0,0,0,0.2), 2px, rgba(255,255,255,0)) scroll no-repeat",
    bodyBackgroundSize: "100% ".concat(xlShadowSize, ", 100% ").concat(xlShadowSize)
  }
};
var StyledModal = exports.StyledModal = _styledComponents["default"].div.attrs({
  className: 'fuse-modal'
}).withConfig({
  displayName: "styled-modal__StyledModal",
  componentId: "sc-1p10y3o-0"
})(["", ""], function (_ref) {
  var open = _ref.open,
    zIndex = _ref.zIndex;
  return "\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\topacity: 0;\n\t\tpointer-events: none;\n\t\tposition: fixed;\n\t\tright: 0;\n\t\ttop: 0;\n\t\ttransition: all 0.2s ease-out;\n\t\tvisibility: ".concat(open ? 'visible' : 'hidden', ";\n\t\tz-index: ").concat(zIndex || "", ";\n\t\toverflow: auto;\n\t\t&.fuse-modal--show {\n\t\t\topacity: 1;\n\t\t\tpointer-events: visible;\n\t\t\ttransition: all 0.2s ease-in;\n\t\t}\n\t");
});
var StyledModalOverlay = exports.StyledModalOverlay = _styledComponents["default"].div.attrs({
  className: 'fuse-modal__overlay',
  'data-testid': 'fuse-modal__overlay'
}).withConfig({
  displayName: "styled-modal__StyledModalOverlay",
  componentId: "sc-1p10y3o-1"
})(["align-items:center;background-color:rgba(0,0,0,0.2);height:100%;width:100%;overflow:auto;"]);
var StyledModalGridContainer = exports.StyledModalGridContainer = (0, _styledComponents["default"])(_grid.GridContainer).attrs({
  className: 'fuse-modal__grid-container',
  'data-testid': 'fuse-grid-container'
}).withConfig({
  displayName: "styled-modal__StyledModalGridContainer",
  componentId: "sc-1p10y3o-2"
})(["height:100%;"]);
var StyledModalGridRow = exports.StyledModalGridRow = (0, _styledComponents["default"])(_grid.GridRow).attrs({
  className: 'fuse-modal__grid-row',
  'data-testid': 'fuse-grid-row'
}).withConfig({
  displayName: "styled-modal__StyledModalGridRow",
  componentId: "sc-1p10y3o-3"
})([""]);
var StyledModalGridItem = exports.StyledModalGridItem = (0, _styledComponents["default"])(_grid.GridItem).attrs({
  className: 'fuse-modal__grid-item',
  'data-testid': 'fuse-grid-item'
}).withConfig({
  displayName: "styled-modal__StyledModalGridItem",
  componentId: "sc-1p10y3o-4"
})([""]);
var StyledModalContainer = exports.StyledModalContainer = _styledComponents["default"].div.attrs({
  className: 'fuse-modal__content',
  'data-testid': 'fuse-modal__content'
}).withConfig({
  displayName: "styled-modal__StyledModalContainer",
  componentId: "sc-1p10y3o-5"
})(["", ";box-shadow:var(--elevation-shadow-l);display:flex;flex-direction:column;max-height:calc( (var(--vh,1vh) * 100) - (", " * 2) );position:relative;width:100%;&:focus{outline:none;}@media only screen and (min-width:", "){max-height:calc( (var(--vh,1vh) * 100) - (", " * 2) );}@media only screen and (min-width:", "){max-height:calc(100vh - (", " * 2));}"], (0, _fuseUtils.BorderRadiusCss)('l'), stylesConfig.xxs.maxHeightMargin, _grid.gridConfig.m.minWidth, stylesConfig.xl.maxHeightMargin, _grid.gridConfig.xl.minWidth, stylesConfig.m.maxHeightMargin);
var StyledModalLink = exports.StyledModalLink = (0, _styledComponents["default"])(_links.Link).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'linkCenterStacked';
  }
}).attrs({
  className: 'fuse-modal__link'
}).withConfig({
  displayName: "styled-modal__StyledModalLink",
  componentId: "sc-1p10y3o-6"
})(["align-items:center;display:flex;justify-content:center;width:100%;@media screen and (min-width:", "){width:", ";}"], _grid.gridConfig.m.minWidth, function (_ref2) {
  var linkCenterStacked = _ref2.linkCenterStacked;
  return linkCenterStacked ? "auto" : "unset";
});
var StyledModalButton = exports.StyledModalButton = (0, _styledComponents["default"])(_buttons.Button).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'linkCenterStacked';
  }
}).attrs({
  className: 'fuse-modal__button'
}).withConfig({
  displayName: "styled-modal__StyledModalButton",
  componentId: "sc-1p10y3o-7"
})(["align-items:center;display:flex;justify-content:center;width:", ";"], function (_ref3) {
  var linkCenterStacked = _ref3.linkCenterStacked;
  return linkCenterStacked ? "100%" : "unset";
});
var StyledModalLinkContainer = exports.StyledModalLinkContainer = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['linkCenterAlignment', 'linkCenterStacked'].includes(prop);
  }
}).attrs({
  className: 'fuse-modal__linkcontainer',
  'data-testid': 'fuse-modal__linkcontainer'
}).withConfig({
  displayName: "styled-modal__StyledModalLinkContainer",
  componentId: "sc-1p10y3o-8"
})(["width:100%;gap:var(--spacing-global-space4);display:flex;flex-direction:column-reverse;@media screen and (min-width:", "){width:", ";flex-direction:", ";}@media only screen and (min-width:", "){align-items:center;}"], _grid.gridConfig.m.minWidth, function (_ref4) {
  var linkCenterStacked = _ref4.linkCenterStacked;
  return linkCenterStacked ? "fit-content" : "unset";
}, function (_ref5) {
  var linkCenterStacked = _ref5.linkCenterStacked;
  return linkCenterStacked ? "column-reverse" : "row";
}, _grid.gridConfig.xl.minWidth);
var StyledModalFooter = exports.StyledModalFooter = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['linkCenterAlignment', 'linkCenterStacked'].includes(prop);
  }
}).attrs({
  className: 'fuse-modal__footer'
}).withConfig({
  displayName: "styled-modal__StyledModalFooter",
  componentId: "sc-1p10y3o-9"
})(["justify-content:", ";padding:var(--spacing-global-space7) var(--spacing-global-space6) var(--spacing-global-space8);width:100%;height:fit-content;display:flex;@media screen and (min-width:", "){background:", ";background-color:var(--color-functional-panelLight);background-size:", ";}@media screen and (min-width:", "){background:", ";background-color:var(--color-functional-panelLight);background-size:", ";}@media only screen and (min-width:", "){background:", ";background-color:var(--color-functional-panelLight);background-size:", ";}"], function (_ref6) {
  var linkCenterAlignment = _ref6.linkCenterAlignment,
    linkCenterStacked = _ref6.linkCenterStacked;
  return linkCenterAlignment || linkCenterStacked ? "center" : "flex-end";
}, _grid.gridConfig.xxs.minWidth, stylesConfig.xxs.bodyBackground, stylesConfig.xxs.bodyBackgroundSize, _grid.gridConfig.m.minWidth, stylesConfig.m.bodyBackground, stylesConfig.m.bodyBackgroundSize, _grid.gridConfig.xl.minWidth, stylesConfig.xl.bodyBackground, stylesConfig.xl.bodyBackgroundSize);
var StyledModalBody = exports.StyledModalBody = _styledComponents["default"].div.attrs({
  className: 'fuse-modal__body',
  'data-testid': 'fuse-modal__body'
}).withConfig({
  displayName: "styled-modal__StyledModalBody",
  componentId: "sc-1p10y3o-10"
})(["min-height:50%;", ""], function (_ref7) {
  var hasPadding = _ref7.hasPadding;
  return "\n        overflow-x: visable;\n        overflow-y: auto;\n\n        padding: ".concat(hasPadding ? stylesConfig.xxs.bodyPadding : "", ";\n        /* Creates shadow at top of modal body to emulate sticky header box-shadow when body is scrolled */\n        background: ").concat(stylesConfig.xxs.bodyBackground, ";\n        background-color: var(--color-functional-panelLight);\n        background-size: ").concat(stylesConfig.xxs.bodyBackgroundSize, ";\n\n        @media only screen and (min-width: ").concat(_grid.gridConfig.m.minWidth, ") {\n            background: ").concat(stylesConfig.m.bodyBackground, ";\n            background-color: var(--color-functional-panelLight);\n            background-size: ").concat(stylesConfig.m.bodyBackgroundSize, ";\n            padding: ").concat(hasPadding ? stylesConfig.m.bodyPadding : "", ";\n        }\n\n        @media only screen and (min-width: ").concat(_grid.gridConfig.xl.minWidth, ") {\n            background: ").concat(stylesConfig.xl.bodyBackground, ";\n            background-color: var(--color-functional-panelLight);\n            background-size: ").concat(stylesConfig.xl.bodyBackgroundSize, ";\n            padding: ").concat(hasPadding ? stylesConfig.xl.bodyPadding : "", ";\n        }\n    ");
});